import { HomeTypeEnum, OwnershipType } from '../enums';

const strings = {
  message: 'Behöver du en snabb visning av värderingstjänsten? Skriv in till info@valueguard.se',
  data: {
    sourceLantmateriet: 'Källa: Lantmäteriet',
    showMapSettings: 'Visa kartinställningar',
    hideMapSettings: 'Dölj kartinställningar',
    loading: 'Laddar',
    deleteAllButton: 'Ta bort valda värderingar',
    editProjectsButton: 'Redigera värderingar',
    error:
      'Det verkar vara något fel just nu med att hämta objekt. Pröva igen om en stund. Om problemet kvarstår, kontakta support@valueguard.se',
    somethingWentWrong: 'Något gick fel, försök igen.',
    somethingWentWrongLogin: 'Inloggningen misslyckades. Säkerställ att du har rätt inloggningsuppgifter och försök igen',
    resetPasswordMessage: 'Se email för instruktioner för att sätta ett nytt lösenord.',
    deleteMultipleSuccess: '@length värderingar har raderats.',
    search: 'Sök',
    advancedSearch: "Om bostaden",
    leaveStreetView: "Lämna street view",
    draw: "Rita område",
    searchPlaceholder: 'Sök...',
    referencePrice: 'Referenspris',
    salesInfo: 'Försäljningsinformation',
    adInfo: 'Annonsinformation',
    realEstateInfo: 'Fastighetsinformation',
    coOperative: 'Bostadsrättslägenhet',
    ownChoice: 'Eget val',
    littleHouse: 'Småhus',
    newSearch: 'Ny värdering',
    created: 'Skapad den',
    noSavedProjects: 'Du har inte sparat några värderingar än',
    noProjectName: 'Namnlös värdering',
    reset: 'Återställ',
    addAdress: 'Ange en adress',
    noHitsFounds: 'Finns inga träffar'
  },
  cookieConsent: {
    title: 'Innan du fortsätter till Valueguard Värderingstjänst',
    description: 'Vi använder cookies för att förbättra din upplevelse på vår webbplats. Genom att fortsätta använda vår webbplats godkänner du att vi använder cookies. För mer information om hur vi använder cookies, ',
    link: 'var god läs vår cookiepolicy här.',
    accept: 'Godkänn alla',
    deny: 'Bara nödvändiga',
    terms: 'Genom att "acceptera alla" eller "Bara nödvändiga" går du med på våra användarvillkor. ',
    termsLink: 'Klicka här för att läsa mer om våra användarvillkor.',
    switchOptionalTitle: 'Prestandacookies',
    switchOptionalDescription: 'Vi samlar in information om hur webbplatsen används, t.ex. vilka sidor som besöks, webbläsare, operativsystem och om fel uppstår.',
    switchRequiredTitle: 'Nödvändiga',
    switchRequiredDescription: 'Möjliggör grundläggande funktioner, såsom inloggning och säker anslutning. Utan dessa kan vi inte tillhandahålla vissa tjänster.',
  },
  dashboard: {
    save: 'Autospara',
    report: 'Rapport',
    hide: 'Dölj sökparametrar',
    downloadExcel: 'Excel',
    excelName: 'Valueguards Värderingstjänst - dataexport',
    resetWarning:
      'Du håller på att återställa alla sökparametrar för vikter och referensvärden. Är du säker?',
    resetWarningHeading: 'Återställ referens och viktinställningar?',
    resetWarningButton: 'Återställ',
    toggleAutoSaveOff: "Klicka för att sätta på autospara",
    toggleAutoSaveOn: "Klicka för att stänga av autospara",
    showPropertyLinesLabel: "Visa fastighetsgränser"
  },
  dialog: {
    cancel: 'Avbryt',
    resetFilter: 'Återställ filter',
    areYouSure: 'Är du säker på att du vill radera?',
    closeWindow: 'Spara och stäng fönster'
  },
  error: {
    orgNr: 'Ingen förening hittad',
    orgNrInvalid: 'Ej giltigt organisationsnummer',
    reportLoadFailed: 'Kunde inte ladda rapport',
    resetFilter: 'Återställ filter',
    notFoundHeader: 'Sidan kunde inte hittas',
    notFoundDetails:
      'Tyvärr så kunde vi inte hitta sidan du letade efter. Välj ett projekt för att gå tillbaka till huvudvyn',
    reportMissing: 'Årsredovisning saknas',
  },
  errorPage: {
    errorSummary:
      'Det verkar vara något fel just nu med att hämta värderingar. Pröva igen om en stund. Om problemet kvarstår, kontakta support@valueguard.se',
  },
  filter: {
    shore: 'Strand',
    filter: 'Filter',
    advertisingDays: 'Annonsdagar',
    all: 'Alla',
    homeType: 'Bostadsform',
    goToOrg: 'Gå till förening',
    contract_date: 'Kontraktsdatum',
    ads_date: 'Annonsdatum',
    activate_about_filter: 'Fyll i information',
    activate: 'Aktivera filter',
    loadingReport: 'Laddar rapport...',
    report: "Årsredovisning",

    orgNr: 'orgNr',
    checkboxItems: {
      orgNr: 'Organisationsnummer',
      firm: 'Mäklarfirma',
      showNewBuilds: 'Visa sannolik nyproduktion och ombildningar',
      inadequateData: 'Visa även bristfälligt data',
      distanceToCenter: 'Närhet till tätort',
    },
    construction_year: 'Byggår',
    distance: 'Geografisk närhet',
    floor: 'Våning',
    floors: 'Antal våningar',
    from: 'Från',
    high: 'Hög',
    housingType: 'Bostadstyp',
    housingTypes: {
      house: 'Villa',
      apartment: 'Lägenhet',
      terracedHouse: 'Kedjehus',
      plot: 'Tomt',
      farm: 'Gård',
      townhouse: 'Radhus',
    },
    living_area: 'Boarea',
    living_area_unit: 'm\u00B2',
    low: 'Låg',
    medium: 'Mellan',
    monthly_fee: 'Månadsavgift',
    monthly_fee_unit: 'SEK',
    none: 'Ingen',
    owner: 'Ägandeform',
    onlySaved: 'Endast sparade',
    ownertypes: {
      co_operative: 'Bostadsrätt',
      property_right: 'Äganderätt',
      site_leasehold: 'Tomträtt',
      lease: 'Arrenderätt',
      other: 'Annan',
    },
    population_center: 'Avstånd till centrum',
    price: 'Pris',
    price_unit: 'mkr',
    relevanse: 'Relevans',
    registeredDate: 'Registrerad',
    rooms: 'Antal rum',
    rooms_unit: 'rum',
    to: 'Till',
    saveFilter: 'Spara filter',
  },
  report: {
    logo: 'logo',
    about: 'Om bostaden',
    report: 'Rapport',
    hide: 'Dölj sökparametrar',
    address: 'Adress',
    rooms: 'Antal rum',
    livingArea: 'Boarea',
    constructionYear: 'Byggår',
    floor: 'Våningsplan',
    addReferencePrice: 'Visa referenspris baserat på sökning',
    comment: 'Skriftlig kommentar',
    pdfcomment: 'Kommentar',
    noValue: 'Inget värde',
    saveClientReportPDF: 'Spara kundrapport (PDF)',
    exportPDF: 'Ladda upp till @integration_name',
    pdfExported: 'Pdf uppladdad',
    pdfUploadError: 'Något gick fel, försök igen',
    saveReportPDF: 'Spara rapport (PDF)',
    licenceText2: '© Valueguard Index Sweden AB. Licensinnehavare: @username. Datum: @date. Detta material får ej vidarebefordras till tredje part.',
    licenceText1: '© Valueguard Index Sweden AB. Licensinnehavare: @username. Datum: @date.',
    priceToday: 'Pris idag',
    referencePrice1: 'Referenspris baserat på ',
    referencePrice2: ' försäljningar:',
    selectedReferencePrice2: ' valda försäljningar:',
    noData: 'Du måste gå in på en flik och göra en analys innan du kan lägga till den i rapporten.',
  },
  login: {
    company: 'Företag',
    contactSupport: 'Kontakta support',
    createAccount: 'Skapa konto',
    email: 'E-postadress',
    emailMessage1: 'Vänligen ange din e-postadress',
    emailMessage2: 'Vänligen ange en giltig e-postadress',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    login: 'Logga in',
    logout: 'Logga ut',
    logo: 'Valueguard Logo',
    mobilePhone: 'Mobil',
    office: 'Kontor',
    officeInfo:
      'Om företaget har flera kontor, ange vilket du hör till. Ange annars din ort.',
    password: 'Lösenord',
    passwordAgain: 'Upprepa lösenord',
    passwordForgot: 'Glömt lösenord?',
    passwordRequest: 'Begär nytt lösenord',
    passwordMessage: 'Vänligen ange ditt lösenord',
    passwordDescription:
      'Ange din e-postadress så skickar vi instruktioner om hur du återställer ditt lösenord',
    passwordVerification:
      'Om användaren finns i systemet så har vi skickat ett email om hur lösenordet kan återställas',
    phone: 'Telefon',
    register: 'Registrera',
    registerAccount: 'Registrera konto',
    registerInfo:
      'Du förbinder dig inte till att köpa något. Vi skickar ingen faktura utan en skriftlig beställning. Vi behandlar dina kontaktuppgifter konfidentiellt.',
    registerInfo2:
      'Observera att tjänsten endast riktar sig till fastighetsmäklare, byggbolag och andra som arbetar med värdering på privatbostadsmarknaden. Den är inte tillgänglig för privatpersoner.',
    loginText: 'Logga in till Värderingstjänst',
    emailUrl: {
      email: 'support@valueguard.se',
      subject: 'Fråga till support',
    },
    togglePasswordOn: 'Visa lösenord',
    togglePasswordOff: 'Dölj lösenord',
    pinTitle: 'Säkerhetsverifiering',
    pinText: 'Ange din säkerhetskod för att fortsätta',
    pinLabel: 'Säkerhetskod',
    pinWrong: 'Fel kod. Försök igen.',
    pinSubmit: 'Verifiera',
    loadingLayers: 'Laddar Pro++-lager...',
    loadingLayersSub: 'Optimerar din upplevelse',
    wrongAccess: "Fel behörighet",
    wrongAccessMessage: "Kontot har fel behörighet. Kontakta support@valueguard.se.",
  },
  sidebar: {
    cookieConsent: "Hantera cookies",
    terms: "Användarvillkor",
    valueService: 'Värderingstjänst',
    valueOldService: 'Gamla Värderingstjänst',
    mapStat: 'MapStat',
    residentialRegistry: 'Bostadsregistret',
    indexService: 'Index',
    savedProjects: 'Sparade värderingar',
    savedValues: 'Sparade värderingar',
    profile: 'Profil',
    error:
      'Det verkar vara något fel just nu med att hämta värderingar. Pröva igen om en stund. Om problemet kvarstår, kontakta support@valueguard.se',
    support: 'Support',
    open: 'Öppna',
    rename: 'Redigera namn',
    delete: 'Ta bort',
    deleteHeading: 'Radera värdering',
    deleteDescription: 'Du håller på att radera denna värdering, är du säker?',
  },
  mapstat: {
    title: 'MapStat',
    areaCategory: 'Områdestyp',
    housingType: 'Bostadstyp',
    method: 'Metod',
    date: 'Datum',
    dynamicColour: 'Dynamisk färgskala',
    lockColour: 'Lås färgskala',
    legend: 'Färgskala',
    search: 'Sök',
    exportPng: 'Exportera PNG',
    exportFileName: 'mapstat',
    exportAttribution: '© OpenStreetMap-bidragsgivare · Källa: Valueguard · valueguard.se',
    loading: 'Hämtar områdesdata...',
    noDataForDate: 'Ingen data hittades för valt datum. Senaste tillgängliga datum har valts.',
    error:
      'Det gick inte att hämta kartdata just nu. Pröva igen om en stund. Om problemet kvarstår, kontakta support@valueguard.se',
  },
  registry: {
    title: 'Bostadsregistret',
    groupAddress: 'Adress',
    groupHouse: 'Fastighet',
    groupLocation: 'Plats',
    groupAdvanced: 'Avancerade inställningar',
    street: 'Gata',
    number: 'Gatunummer',
    apartmentNr: 'Lägenhetsnummer',
    letter: 'Bokstav',
    postalArea: 'Postort',
    postalCode: 'Postnummer',
    propertyKey: 'Fastighetsbeteckning',
    countyCode: 'Län',
    municipalityCode: 'Kommun',
    limit: 'Max antal resultat',
    residentialIds: 'Bostads-ID',
    fetchAll: 'Hämta alla',
    fetchAllInfo: 'Hämtar samtliga träffar sida för sida, oavsett max antal resultat.',
    fetchProgress: '@fetched av @total hämtade',
    fetchProgressUnknown: '@fetched hämtade...',
    noRegionMatch: 'Ingen träff – välj från listan eller ange en kod.',
    tooManyCombos: 'För många kombinationer av sökvärden. Ta bort några värden och försök igen.',
    search: 'Sök',
    results: 'Bostäder',
    chooseColumns: 'Välj kolumner',
    hideMap: 'Dölj karta',
    showMap: 'Visa karta',
    chooseColumnsInfo: 'Välj vilka kolumner som ska visas. Ditt val sparas automatiskt.',
    exportExcel: 'Excel',
    exportCsv: 'CSV',
    exportFileName: 'bostadsregistret',
    noResults: 'Inga resultat hittades för dina sökkriterier.',
    error:
      'Sökningen misslyckades just nu. Pröva igen om en stund. Om problemet kvarstår, kontakta support@valueguard.se',
    columns: {
      id: 'ID',
      address: 'Adress',
      construction_year: 'Byggår',
      home_type: 'Bostadstyp',
      apartment_area: 'Boarea',
      apartment_category: 'Lägenhetskategori',
      apartment_nr: 'Lägenhetsnummer',
      area_name: 'Områdesnamn',
      building_purpose: 'Byggnadsändamål',
      building_type: 'Byggnadstyp',
      county_code: 'Länskod',
      municipality_code: 'Kommunkod',
      floor: 'Våning',
      floors: 'Antal våningar',
      kitchen_type: 'Kökstyp',
      ownership_type: 'Upplåtelseform',
      postal_area: 'Postort',
      property_key: 'Fastighetsbeteckning',
      rooms: 'Antal rum',
      type_code: 'Typkod',
    },
  },
  indexApp: {
    title: 'Index',
    searchHeading: 'Hitta index',
    searchPlaceholder: 'Sök adress eller plats',
    homeType: 'Bostadstyp',
    indexId: 'Index-ID',
    addById: 'Lägg till',
    selectedIndexes: 'Valda index',
    mapHint: 'Klicka på kartan för att hämta index för en plats',
    from: 'Från',
    to: 'Till',
    baseValue: 'Startvärde',
    monthsShort: 'mån',
    development: 'Utveckling',
    exportExcel: 'Excel',
    exportCsv: 'CSV',
    exportPng: 'PNG',
    exportFileName: 'valueguard-index',
    exportAttribution: 'Källa: Valueguard · valueguard.se',
    remove: 'Ta bort',
    changeColor: 'Ändra färg',
    chooseOnClick: 'Välj index vid klick på kartan',
    pointListTitle: 'Index för punkten',
    pointListEmpty: 'Inga index hittades för punkten.',
    pointListAdd: 'Lägg till',
    homeTypeNames: {
      apartment: 'Bostadsrätt',
      house: 'Villa/radhus',
    },
    maxReached: 'Du kan jämföra högst @max index samtidigt. Ta bort ett index för att lägga till ett nytt.',
    empty: 'Sök efter en plats, klicka på kartan eller ange ett index-ID för att lägga till ett index.',
    noPlaceFound: 'Ingen träff på sökningen.',
    error:
      'Det gick inte att hämta indexdata just nu. Pröva igen om en stund. Om problemet kvarstår, kontakta support@valueguard.se',
  },
  navigation: {
    sold: 'Sålda',
    ads: 'Till salu',
    market: 'Marknad',
    priceDev: 'Prisutveckling',
    report: 'Rapport',
    mapTypeNames: {
      terrain: "Terrängvy",
      satellite: "Satelitvy",
      hybrid: "Hybridvy",
      roadmap: "Vägvy",
    }
  },
  market: {
    noMarketRights: "Du har ej tillgång till Marknadsandelar. Skriv till info@valueguard.se för att låsa upp!",
    ads: 'Annonser',
    error:
      'Det verkar vara något fel just nu med att hämta marknadsuppgifter. Pröva igen om en stund. Om problemet kvarstår, kontakta support@valueguard.se',
    adDate: 'Annonsdatum',
    chartLabel: 'Mäklare',
    housingType: 'Bostadstyp',
    ownership: 'Ägandeform',
    othersLabel: 'Övriga',
    showMore: 'Visa alla',
    showLess: 'Visa mindre',
  },
  priceDevelopment: {
    pageHeading: 'Prisutveckling i området',
    compareReferenceIndex: 'Jämför med referensindex',
    error:
      'Det verkar vara något fel just nu med att hämta prisutveckling. Pröva igen om en stund. Om problemet kvarstår, kontakta support@valueguard.se',

    chartLabel: 'Pris',
    noDataHeading: 'Inga listningar hittades',
    noDataText:
      'Tyvärr finns det inga listningar som matchar dina sökkriterier. Justera dina filter och försök igen.',
    refPriceBasedOn: 'Referenspris baserat på',
    refPriceBasedOnDefault:
      'Referenspris baserat på antal träffar. Referenspriset är snittet av indexuppräknade kvadratmeterpriser hos referensförsäljningarna, multiplicerat med boarean för det objekt du värderar.',
    hits: 'träffar.',
    moreInfo:
      ' Referenspriset är snittet av indexuppräknade kvadratmeterpriser hos referensförsäljningarna, multiplicerat med boarean för det objekt du värderar.',
    selectedObjects:
      'valda objekt. Referenspriset är snittet av indexuppräknade kvadratmeterpriser hos referensförsäljningarna, multiplicerat med boarean för det objekt du värderar.',
    showOrdinaryStatus: 'Visa ordinarie status',
    showEmptyState: 'Visa tomt tillstånd',
    obs: 'Observera att den faktiska prisutvecklingen för det aktuella objektet kan skilja sig från prisutvecklingen för området. Läs mer om Valueguards index i Värderingstjänsten.',
    pricePerSqm: 'kr/m\u00B2',
    priceCurrency: 'kr',
    graphIndex: 'Index',
    graphSold: 'Referenspris från sålda',
    graphSoldSqm: 'Referenspris från sålda i kr per kvm',
    homeTypeApartments: 'Bostadsrätter',
    homeTypeHouses: 'Småhus',
  },
  table: {
    noExcelExport: 'Du har ej tillgång till Excelexport av data. Skriv till info@valueguard.se för att låsa upp!',
    marketError:
      'Det verkar vara något fel just nu med att hämta marknadsuppgifter. Pröva igen om en stund. Om problemet kvarstår, kontakta support@valueguard.se',

    noDataHeading: 'Börja din Bostadsvärdering',
    hide: 'Dölj',
    link: 'Länk',
    columnHeader: 'Kolumner',
    columnButtonInfo: 'Anpassa kolumner',
    showHiddenRows: 'Visa dolda objekt',
    resetSorting: 'Återställ sortering',
    columnWarning:
      'Du har valt många kolumner vilket riskerar att information kan kapas i dokumentet',
    noDataText:
      'Ange en adress och fyll i information om objektet du ska värdera för att hitta relevanta referensförsäljningar',
    footers: {
      distance: 'Avstånd: ',
    },
    columns: {
      id: 'ID',
      active: 'Aktiv',
      adDate: 'Annonsdatum',
      adDays: 'Dagar ute',
      ancillaryArea: 'Biarea',
      biArea: 'Biarea',
      constructionYear: 'Byggår',
      homeType: 'Bostadstyp',
      contractDate: 'Säljdatum',
      firm: 'Mäklarfirma',
      floorFloors: 'Våning/ Våningar',
      floor: 'Våning',
      floors: 'Antal våningar',
      letter: 'Bokstav',
      isFpr: 'is_fpr',
      livingArea: 'Boyta',
      monthlyFee: 'Avgift',
      number: 'Nummer',
      ownSale: 'Förening',
      plotArea: 'Tomtarea',
      price: 'Utgångspris',
      soldPrice: 'Pris',
      pdf: 'Annons',
      priceSqm: 'Pris/m\u00B2',
      priceToday: 'Pris idag/m\u00B2',
      rooms: 'Rum',
      rt90x: 'rt90x',
      rt90y: 'rt90x',
      recountedPrice: 'Pris idag',
      adPrice: 'Utgångspris',
      registeredDate: 'Annonsdatum',
      relevance: 'Relevans',
      sold_price: 'Pris',
      street: 'Adress',
      priceTaxationRatio: 'K/T-tal',
      soldPriceSqm: 'Pris/m\u00B2',
      recountedPriceSqm: 'Pris/m\u00B2 idag',
      taxationValue: 'Taxeringsvärde',
      taxationYear: 'Taxeringsår',
      monthlyFeeSqm: 'Avgift /m\u00B2',
      source: 'Källa',
      adRegisteredDate: 'Annonsdatum',
      adDeleteDate: 'Datum borttaget',
      adAvertisingDays: 'Liggtid',
      adAdvertisingDays: 'Liggtid',
      advertisingDays: 'Liggtid',
      adPriceSqm: 'Utgångspris/m\u00B2',
      prospectUrl: 'VG Prospekt',
      ownershipType: 'Ägendeform',
      ownerName: 'Föreningsnamn',
      ownerId: 'Organisations- nummer',
      propertyUnitDesignation: 'Fastighets- beteckning',
      allabolagUrl: 'allabolag.se',
      allabrfUrl: 'allabrf.se',
      valuationYear: 'Värdeår',
      shoreDistanceType: 'Strand',
      waterSewerageType: 'VA',
      alterationYear: 'TBÅ',
      standardPoints: 'SP',
      leaseholdFee: 'Tomträtts- avgäld',
      leaseholdPeriod: 'Löptid avgäld',
      subdivisionType: 'Fastighetsrättsliga förhållanden',
      housingAssociationReportYear: 'BRF årsredovisning',
      balcony: 'Balkong',
      elevator: 'Hiss',
    },
    tooltip: {
      contractDate:
        'Om försäljningen ursprungligen kommer från mäklardata så visas här kontraktsdatum, annars visas lagfartsdatum.',
      floorFloors: 'Våningsplan. OBS att ett "--" ofta betyder bottenplan',
      recountedPrice:
        'Visar ett indexerat försäljningspris, dvs. vad priset motsvarar idag om man justerar för den genomsnittliga prisutvecklingen i området. Se ”Prisutveckling” för att se vilket prisindex som använts. ',
      source: 'M = Mäklare, L = Lantmäteriet',
      monthlyFeeSqm: 'Månadsavgift per kvadratmeter',
      shoreDistanceType:
        '1 = (Strand) högst 75 m och egen strand\n2 = (Strandnära) högst 75 m utan egen strand\n3 =  (Strandnära) mer än 75 m men högst 150 m\n4 = (Inte strand eller strandnära) mer än 150 m',
      waterSewerageType:
        'Tillgång till vatten och avlopp\nTiotalssiffran:\n1 = Kommunalt vatten året om\n2 = Enskilt vatten året om\n3 = Kommunalt/Enskilt sommarv  \n4 = Vatten saknas\nEntalssiffran:\n1 = Kommunalt avlopp\n2 = Enskilt avlopp\n3 = Avlopp saknas',
      hide: 'Dölj objekt från listan',
      advertisingDays:
        'Antal dagar sedan vi först fick in annonsen. Observera att vissa ”kommande försäljningar” etc kan vilseleda statistiken.',
      alterationYear: 'Tillbyggnadsår',
      standardPoints: 'Standardpoäng',
      subdivisionType:
        'Fastighetsrättsliga förhållanden på småhusmark \n00 = Uppgift saknas \n01 = Självständig \n02 = Avstyckningsbar \n03 = Ej avstyckningsbar',
    },
  },
  months: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Maj',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dec',
  ],
};

export const homeTypes: { [key in HomeTypeEnum]: string } = {
  [HomeTypeEnum.apartment]: strings.filter.housingTypes.apartment,
  [HomeTypeEnum.house]: strings.filter.housingTypes.house,
  [HomeTypeEnum.farm]: strings.filter.housingTypes.farm,
  [HomeTypeEnum.terracedHouse]: strings.filter.housingTypes.terracedHouse,
  [HomeTypeEnum.townhouse]: strings.filter.housingTypes.townhouse,
  [HomeTypeEnum.plot]: strings.filter.housingTypes.plot,
};

export const ownershipTypes: { [key: string]: string } = {
  [OwnershipType.coOperativeApartment]: strings.filter.ownertypes.co_operative,
  [OwnershipType.propertyRights]: strings.filter.ownertypes.property_right,
  [OwnershipType.siteLeasehold]: strings.filter.ownertypes.site_leasehold,
  [OwnershipType.lease]: strings.filter.ownertypes.lease,
  [OwnershipType.other]: strings.filter.ownertypes.other,
};

export default strings;
